import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import SideBar from "../../../components/Layout/SideBar";
import { useNavigate, useParams } from "react-router-dom";
import Return from "../../../assets/icons/return.svg";
import TableAndUploadFile from "../../../components/Cac/Partner/WorkingFolder/TableAndUploadFile";
import UsersAffectedWorkingFolder from "../../../components/Cac/Partner/WorkingFolder/UsersAffectedWorkingFolder";
import { usePartnerWorkingFolderStore } from "../../../stores/Cac/Partner/partnerWorkingFolder";
import ModalDeleteWorkingFolder from "../../../components/Cac/Partner/WorkingFolder/ModalDeleteWorkingFolder";
import { useEffect } from "react";
import {
  getPartnerAssociated,
  getWorkingFolderData,
} from "../../../services/Api/customerService";
import AddUserWorkingFolder from "../../../components/Cac/Partner/WorkingFolder/AddUserWorkingFolder";
import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import { showToastError } from "../../../services/Toasts/toasts";

const PartnerWorkingFolder = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    setChoiceModalWF,
    workingFolderDetails,
    setWorkingFolderDetails,
    updateWorkingFolder,
    setAddUserModal,
    manager,
    setManager,
    setCollabsAssignedToClient,
    setCheckboxValuesCollabs,
  } = usePartnerWorkingFolderStore();
  const { idCustomer, idWorkingFolder } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Récupération des détails du dossier de travail
        const dataWF = await getWorkingFolderData(
          Number(idCustomer),
          Number(idWorkingFolder)
        );
        setWorkingFolderDetails(dataWF);

        // Définition du manager
        const manager = dataWF?.workingFolder?.partnerUsers?.find(
          (user: any) => user.isManager === true
        );
        setManager(manager);

        // Récupération des partenaires associés
        const partnerData = await getPartnerAssociated(Number(idCustomer));
        const filteredData = partnerData?.filter(
          (collab: any) => collab.id !== manager.idUser
        );

        // Mappage des données
        const mappedData: { [key: number]: any } = {};
        filteredData.forEach((assignUser: any) => {
          mappedData[assignUser.id] = assignUser;
        });
        setCollabsAssignedToClient(Object.values(mappedData));

        // Définition des valeurs des checkboxes
        const checkboxValues: { [key: number]: boolean } = {};
        Object.values(filteredData).forEach((assignUser: any) => {
          checkboxValues[assignUser.id] =
            dataWF?.workingFolder?.partnerUsers?.some(
              (user: any) => user.idUser === assignUser.id
            );
        });
        setCheckboxValuesCollabs(checkboxValues);
      } catch (error) {
        showToastError(t("common.error"));
      }
    };

    fetchData();
  }, [updateWorkingFolder]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <div className="w-full flex justify-start items-start h-full">
        <SideBar />
        <ToastContainer position="top-center" />
        <ModalDeleteWorkingFolder />
        <div className="flex flex-col justify-start items-center w-11/12 h-10/12 mx-auto overflow-hidden">
          {/* Header Section avec design moderne */}
          <div className="w-full bg-white rounded-2xl shadow-lg p-3 sm:p-4 my-2 sm:my-3 border border-gray-100 flex-shrink-0">
            <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-3 sm:gap-4">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="p-2 sm:p-3 bg-blue-100 rounded-xl">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <h1 className="text-lg sm:text-xl font-bold text-gray-700 font-K2D truncate">
                    {t("partner.workingFolderTitle")} :{" "}
                    <span className="text-blue-600">
                      {workingFolderDetails?.workingFolder?.nameCustomer}
                    </span>
                  </h1>
                  <p className="text-gray-600 text-sm sm:text-md mt-1 truncate">
                    {t("common.manager")} :{" "}
                    <span className="font-semibold text-gray-700">
                      {manager?.firstName + " " + manager?.lastName}
                    </span>
                  </p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 w-full xl:w-auto">
                <button
                  onClick={() => setAddUserModal(true)}
                  className="px-3 sm:px-4 py-2 bg-blue-600 text-white cursor-pointer font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2 text-sm sm:text-base"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  <span className="hidden sm:inline">{t("partner.addAccess")}</span>
                  <span className="sm:hidden">{t("partner.add")}</span>
                </button>
                <button
                  onClick={() => setChoiceModalWF("delete")}
                  className="px-3 sm:px-4 py-2 bg-red-500 text-white cursor-pointer font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2 text-sm sm:text-base"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  <span className="hidden sm:inline">{t("common.delete")}</span>
                  <span className="sm:hidden">{t("partner.deleteShort")}</span>
                </button>
              </div>
            </div>
            {/* Bouton retour avec design moderne */}
            <div className="w-full flex justify-start mt-2">
              <button
                type="button"
                className="flex items-center gap-2 px-3 sm:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-white rounded-xl transition-all duration-200 bg-gray-100 cursor-pointer text-sm sm:text-base"
                title={t("common.back")}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <img src={Return} alt="return" className="w-4 h-4 sm:w-5 sm:h-5" />
                <span className="font-medium">{t("common.back")}</span>
              </button>
            </div>
          </div>

          {/* Modal pour ajouter un utilisateur */}
          <AddUserWorkingFolder />

          {/* Contenu principal avec design moderne */}
          <div className="w-full grid grid-cols-1 xl:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6 flex-1 min-h-0 h-1/2">
            {/* Section fichiers et table */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 flex flex-col min-h-0">
              <div className="p-3 border-b border-gray-100 flex-shrink-0">
                <h3 className="text-base sm:text-lg font-semibold text-gray-700 font-K2D">
                  {t("partner.filesAndDocuments")}
                </h3>
              </div>
              <div className="p-3 sm:p-4 flex-1 min-h-0">
                <TableAndUploadFile />
              </div>
            </div>

            {/* Section utilisateurs affectés */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 flex flex-col min-h-0">
              <div className="p-3 sm:p-4 flex-1 min-h-0">
                <UsersAffectedWorkingFolder />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PartnerWorkingFolder;
